import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { getAssignees, bulkAssign } from '../../CroActions';
import { fetchM } from '../../../../utils/fetch';
import ControlBatchDetailGrid from '../../components/grids/ControlBatchDetailGrid';
import AssigneeBulkAssignDialog from "../../components/AssigneeBulkAssignDialog";

class ControlBatchDetail extends Component {
    state = {
        selectedIds: [],
        dialogOpen: false,
        pendingAssigneeId: '',
        items: [], // dummy reload trigger
        assignees: null,
    };

    async componentDidMount() {
        this.props.breadcrumbs([
            { label: 'Generátor kontroly veřejných funkcionářů', path: '/administrator/kontrola' },
            { label: 'Detail kontrolní dávky' },
        ]);
        const assignees = await getAssignees(this.props.dispatch);
        this.setState({ assignees: assignees?.items || [] });
    }

    onAssign = (itemId, assigneeId) => {
        fetchM(`/administrator/api/kontrola/${this.props.params.id}/items/${itemId}/assign`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: assigneeId ? JSON.stringify({ id: assigneeId }) : null,
        }).then((response) => {
            if (response.ok) this.reloadGrid();
        });
    }

    onShowAssign = (selectedIds) => {
        this.setState({ selectedIds, dialogOpen: true, pendingAssigneeId: '' });
    }

    onCancel = () => {
        this.setState({ dialogOpen: false, pendingAssigneeId: '' });
    }

    onConfirm = async () => {
        const { selectedIds, pendingAssigneeId } = this.state;
        const { dispatch, auth } = this.props;

        await bulkAssign({
            url: `${auth.startUrl}/api/kontrola/${this.props.params.id}/items/prideleni`,
            itemIds: selectedIds,
            assigneeId: pendingAssigneeId || null,
        })(dispatch);

        this.setState({ dialogOpen: false, selectedIds: [], pendingAssigneeId: '' });
        this.reloadGrid();
    }

    reloadGrid = () => {
        this.setState({ items: [...this.state.items, 0] });
    }

    onRowClick = (row) => {
        if (row.official) {
            this.props.push(`/administrator/funkcionari/form/${row.official.id}`);
        }
    }

    render() {
        const { dialogOpen, selectedIds, pendingAssigneeId, items, assignees } = this.state;

        return (
            (assignees && <div>
                <ControlBatchDetailGrid
                    gridName="controlBatchDetailGrid"
                    url={`/administrator/api/kontrola/${this.props.params.id}/items`}
                    sort="officialLastName"
                    items={items}
                    onRowClick={this.onRowClick}
                    assignees={assignees}
                    onAssign={this.onAssign}
                    allowCheck={true}
                    moreCheckboxFns={true}
                    fnText="Přidělit zpracovatele"
                    onCheckboxFn={this.onShowAssign}
                />

                <AssigneeBulkAssignDialog
                    open={dialogOpen}
                    selectedCount={selectedIds.length}
                    assignees={assignees}
                    assigneeId={pendingAssigneeId}
                    onAssigneeChange={(id) => this.setState({ pendingAssigneeId: id })}
                    onConfirm={this.onConfirm}
                    onCancel={this.onCancel}
                />
            </div>)
        );
    }
}

const mapStateToProps = (state) => ({ auth: state.sidebar.auth });

export default connect(
    mapStateToProps,
    (dispatch) => ({
        dispatch,
        breadcrumbs: (...args) => dispatch(breadcrumbs(...args)),
        push: (path) => dispatch(push(path)),
    }),
)(ControlBatchDetail);